export enum ModosEnum {
    LIST = 1,
    EDIT = 2,
    ADD = 3,
}
